import React from "react";
import Tile from "../../components/Tile/Tile";
import "./ExploreCareers.css";
import { ContentfulTileProps } from "../../utils/contentful-helpers";
import { bookmarkEventBuilder, sendEvent } from "../../utils/event-helpers";
import { useWithSessionData } from "../../hooks/use-with-session-data";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { toggleResourceBookmark } from "../../features/bookmark/resourceBookmarksSlice";

export interface ExploreCareersTilesProps {
  resourceTiles: ContentfulTileProps[];
}

const ExploreCareersTiles = ({
  resourceTiles,
}: ExploreCareersTilesProps) => {
  const { userId, sessionId } = useWithSessionData();
  const dispatch = useAppDispatch();
  const bookmarks = useAppSelector((state) => state.resourceBookmarks.bookmarkedResources);
  const handleBookmarkExploreCareers = (resourceTile: ContentfulTileProps) => {
    const { id, title, description, thumbnail, url } = resourceTile;
    const isBookmarked = bookmarks.some((bookmark) => bookmark.id === id);
    const eventData = bookmarkEventBuilder(!isBookmarked, userId, sessionId, "ExploreCareersTile", title, {
      bookmarkedResource: {
        title: title,
        description: JSON.stringify(description),
        resource_id: id,
      },
    });
    sendEvent(eventData);

    dispatch(
      toggleResourceBookmark({ id, title, description, thumbnail, url })
    );
  };

  return (
    <div className="internship-wrapper">
      <div className="explore-careers-container">
        {resourceTiles.map((tile) => (
          <Tile
            key={tile.id}
            id={tile.id}
            title={tile.title}
            description={tile.description}
            thumbnail={tile.thumbnail}
            url={tile.url}
            isResearchPage={false}
            onBookmark={() => {
              handleBookmarkExploreCareers(tile);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ExploreCareersTiles;
